import React from "react";
import Layout from "./Layout";
import useProps from "./useProps";

export default () => <Layout {...useProps()} />;
